const audiences = [
  {
    title: "Active Options Traders",
    description:
      "Stop manually scanning news feeds. Aegis Vol surfaces the events that matter for volatility — and tells you the right structure to use.",
    icon: "📊",
    items: [
      "Event classification on earnings, M&A, regulatory news",
      "Long gamma vs directional breakout routing",
      "Defined-risk trade intent generation",
      "Stand-down on conflicting signals",
    ],
  },
  {
    title: "Proprietary Trading Desks",
    description:
      "An auditable, reproducible intelligence layer built for teams that need to understand every decision made.",
    icon: "🏛️",
    items: [
      "Full decision audit trail",
      "Configurable scoring thresholds",
      "Broker-agnostic trade intents",
      "Schema-validated LLM outputs",
    ],
  },
  {
    title: "Quant Researchers",
    description:
      "A structured pipeline for event-driven research. Every raw item, score, and LLM output is stored for backtesting and iteration.",
    icon: "🔬",
    items: [
      "Append-only event log for research",
      "Versioned scoring and routing logic",
      "Backtestable decision pipeline",
      "Event thread history and clustering stats",
    ],
  },
];

export default function Audience() {
  return (
    <section className="py-24 sm:py-32 border-t border-navy-700/60">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <p className="text-sm font-semibold uppercase tracking-widest text-huskly-teal mb-4">
            Who It's For
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white">
            Intelligence for Serious Market Participants
          </h2>
          <p className="mt-4 text-slate-400 leading-relaxed">
            Aegis Vol is built for practitioners who prioritize decision quality
            over predicting the unpredictable.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {audiences.map((a) => (
            <div
              key={a.title}
              className="relative rounded-xl border border-navy-700 bg-navy-800/40 p-8 flex flex-col gap-5"
            >
              <div className="text-3xl">{a.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  {a.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed">
                  {a.description}
                </p>
              </div>
              <ul className="flex flex-col gap-2 mt-auto">
                {a.items.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-2 text-sm text-slate-400"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      className="h-4 w-4 text-huskly-green shrink-0 mt-0.5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.5 12.75l6 6 9-13.5"
                      />
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
